/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filter_PublishedInputs */

const cs_filter_published = /** @type {(inputs: Filter_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publikováno`)
};

const en_filter_published = /** @type {(inputs: Filter_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Published`)
};

/**
* | output |
* | --- |
* | "Published" |
*
* @param {Filter_PublishedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const filter_published = /** @type {((inputs?: Filter_PublishedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_PublishedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filter_published(inputs)
	return cs_filter_published(inputs)
});